<template>
    <div class="main">
        <!--顶部-->
        <div class="trendtop orangeToYellow">
            <div
                class="trendtop_left fs40 ellipsis"
                :class="ischange == true ? 'on' : ''"
                @click="showChangeTrend"
            >
                <p>{{ dname }}</p>
            </div>
        </div>
        <van-popup
            v-model="ishow"
            position="bottom"
            :style="{ height: '40%' }"
            @click-overlay="onCancel"
        >
            <van-picker
                :title="$t('trend.trend_chose')"
                :confirm-button-text="$t('member.login_out_ok')" :cancel-button-text="$t('member.login_out_cancel')"
                show-toolbar
                :columns="monlist"
                :default-index="des"
                @confirm="onConfirm"
                @cancel="onCancel"
            />
        </van-popup>
        <!--顶部 end-->

        <!--阀门列表-->
        <div class="valist">
            <div class="va" v-for="(item, index) in valist" :key="index" >
                <div class="vatop">
                    <div class="valeft">
                        <div class="va_title fs30">{{item.name}}
                            <span class="fs24 txt2">{{$t('valva.port_name')}}：{{item.portNo}}</span>
                        </div>
                        <div class="va_time fs26"><img src="../../assets/images/gtim.png" class="img1" />{{item.lastUpdate}}</div>
                    </div>
                    <div class="varight">
                        <van-switch v-model="item.sw" @click="switchStt(item.id,item.sw)" active-value="1" inactive-value="0" active-color="#1989fa" inactive-color="#ccc" size="24" />
                    </div>
                </div>
                <div class="vatask">
                    <div class="vatask_left fs26" v-show="item.tasknum>0">
                        <font color="#f00">{{item.tasknum}}</font>{{$t('first.task_num')}}
                    </div>
                    <div class="vatask_left fs26" v-show="item.tasknum==0">{{$t('first.notask')}}</div>
                    <div class="vatask_right">
                        <a href="javascript:;" @click.prevent="goTaskList(item.id)" class="orangeToYellow fs26" v-show="item.tasknum>0">{{$t('first.task_see')}}</a>
                        <a href="javascript:;" @click.prevent="goTaskList(item.id)" class="orangeToYellow fs26" v-show="item.tasknum==0">{{$t('first.task_created')}}</a>
                    </div>
                </div>
            </div>
        </div>
        <!--阀门列表 end-->

        <!-- <div class="doexcel" @click="doSendEmail">{{$t('valva.val_btn')}}</div> -->
        <pageToast ref="pageToast"></pageToast>
        <customFooter :ison="2"></customFooter>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                currentDate: new Date(),
                index: 0,
                kind: 0,
                ishow: false,
                ischange: false,
                isreferesh: false,
                no: localStorage.getItem("no") ? localStorage.getItem("no") : "",
                dname: localStorage.getItem("dname")? localStorage.getItem("dname") : "", //设备名称
                monlist: [],
                isopen: '1',
                chart: "",
                devicelist: "", // 所有设备列表
                choselist: "", // 选中的设备
                des: "", // 选中设备索引
                valist: '' // 阀门列表
            }
        },
        created(){

        },
        mounted() {
            // 创建图表
            this.$nextTick(function() {
                this.getDeviceList();
            });
        },
        methods: {
            goTaskList(id) {
                this.$router.push({
                    path: '/tasklist',
                    query: {id: id}
                })
            },

            // 设备选择
            showChangeTrend() {
                this.ishow = true;
                this.ischange = true;
            },

            setShade(){
                this.ischange = false;
                this.ishow = false;
            },


            //查询设备列表
            getDeviceList(num) {
                this.$toast.loading({
                    message: this.$t('live.read_loading'),
                    forbidClick: true,
                    duration: 0
                });
                var _this = this;
                this.$api.getDeviceList({}).then(res => {
                    _this.$toast.clear();
                    if (res.errcode == 0) {
                        var des = _this.des;
                        var dname = _this.dname;
                        var devicelist = res.data;
                        var choselist = "";
                        var monlist = new Array();
                        if (!_this.$isblank(devicelist)) {
                            if (_this.$isblank(dname)) {
                                des = 0;
                            } else {
                                for (var i = 0; i < devicelist.length; i++) {
                                    if (devicelist[i].deviceName == dname) {
                                        des = i;
                                    }
                                }
                            }
                            for (var i = 0; i < devicelist.length; i++) {
                                monlist.push(devicelist[i].deviceName);
                            }

                            choselist = devicelist[des];
                            _this.choselist = choselist;
                            _this.devicelist = devicelist;
                            _this.des = des;
                            _this.monlist = monlist;

                            localStorage.setItem("no", choselist["no"]);
                            localStorage.setItem("dname",choselist["deviceName"]);

                            _this.getValaveList(choselist.no);
                            _this.$refs.pageToast.type = 0;
                        } else {
                            //没有设备列表
                            _this.$refs.pageToast.type = 1;
                        }
                    } else {
                        //其他异常
                        _this.$toast.clear();
                        _this.$toast(this.$t('common.nodata'));
                    }
                }).catch(err => {
                    //其他异常
                    _this.$toast.clear();
                    //_this.$toast("连接超时22");
                });
            },

            // 查询阀门
            getValaveList(no){
                if(this.$isblank(no)){
                    this.$toast(this.$t('export.tis_dev'));return false;
                }
                var _this = this;
                this.$api.getValaveList({
                    gatewayNo: no
                }).then(res => {
                    console.log(res);
                    if (res.errcode == 0) {
                        if(!_this.$isblank(res.list)){
                            var list = res.list;
                            for(var i = 0;i < list.length; i++){
                                list[i].sw = list[i].switchStt.toString();
                                list[i].tasklist = '';
                                list[i].tasknum = 0;
                                _this.getValvaTaskList(list[i].id,i);
                            }
                            _this.valist = list;
                        }else{
                            _this.$refs.pageToast.type = 1;
                        }
                    }else{
                        _this.$toast(res.errmsg);return false;
                    }
                });
            },
            // 阀门开闭
            switchStt(id,value){
                this.$toast.loading({
                    message: this.$t('valva.val_loading'),
                    forbidClick: true,
                    duration: 0
                });
                if(this.$isblank(id)){
                    this.$toast(this.$t('valva.val_chose'));return false;
                }
                if(value==1){
                    var ch = false;
                    var cn = this.$t('valva.val_close');
                }else{
                    var ch = true;
                    var cn = this.$t('valva.val_open');
                }
                var _this = this;
                this.$api.setValaveDetail({
                    gatewayNo: _this.no,
                    id: id,
                    switchStt: ch
                }).then(res => {
                    _this.$toast.clear();
                    if(res.errcode==0){
                        _this.$toast.success(_this.$t('trend.trend_valve')+ cn +_this.$t('valva.val_success'));
                    }else{
                        _this.$toast(res.errmsg);return false;
                    }
                });
            },

            // 读取任务列表
            getValvaTaskList(id,i){
                var _this = this;
                this.$api.getValvaTaskList({
                    valveId: id
                }).then(res => {
                   if(res.errcode==0){
                       var list = [res.data];
                       _this.valist[i].tasklist = list;
                       _this.valist[i].tasknum = list.length;
                   }else{
                       _this.$toast(res.errmsg);return false;
                   }
                });
            },

            //设备点击
            onConfirm(value, index) {
                this.ischange = false;
                this.ishow = false;
                this.dname = value;
                localStorage.setItem("dname", value);
                var devicelist = this.devicelist;
                var choselist = "";
                var des = this.des;
                if (!this.$isblank(devicelist)) {
                    if (this.$isblank(this.dname)) {
                        des = 0;
                    } else {
                        for (var i = 0; i < devicelist.length; i++) {
                            if (devicelist[i].deviceName == value) {
                                console.log(devicelist[i].deviceName, value);
                                des = i;
                                this.no = devicelist[i].no;
                            }
                        }
                    }
                    choselist = devicelist[des];
                    localStorage.setItem("no", choselist.no);
                    this.des = des;
                    this.choselist = choselist;
                    this.getValaveList(choselist.no);
                }
            },

            //设备选择取消
            onCancel(e) {
                this.ischange = false;
                this.ishow = false;
            },


        }
    }
</script>

<style>
body{ background: #f4f4f4;}
/*top*/
/*top*/
.trendtop {overflow: hidden;line-height: 30px;padding: 15px 10px;position:fixed;top:0;left:0;width:100%;box-sizing: border-box;z-index:9999999999;box-shadow:0 0 2px rgba(0, 0, 0, 0.3); text-align: center;}
.trendtop .trendtop_left {color: #fff;padding: 0 0.4rem 0 0; display: inline-block; position: relative;max-width: 3rem;font-size: 15px;font-weight: 700;}
.trendtop .trendtop_left .number {font-size: 13px;font-weight: normal;opacity: 0.7;line-height: 1;}
.trendtop .trendtop_left::after {position: absolute;content: "";width: 0.14rem;height: 0.14rem;border-top: 2px solid #fff;border-right: 2px solid #fff;transform: rotate(45deg);top: 50%;margin-top: -0.09rem;right: 0.1rem;-webkit-transition: all 0.3s ease 0s;-o-transition: all 0.3s ease 0s;transition: all 0.3s ease 0s;}
.trendtop .trendtop_left.on::after {-webkit-transform: rotate(135deg);-moz-transform: rotate(135deg);-o-transform: rotate(135deg);-ms-transform: rotate(135deg);transform: rotate(135deg);}
.trendtop .trendtop_right {float: right;overflow: hidden;color: #fff;opacity: 0.5;font-weight: 700;font-size: 12px;height: 30px;line-height: 30px;position: relative;padding-right:16px;}
.trendtop .trendtop_right .img1 {width: 12px;height: 12px;float: right;margin-left: 5px;position: absolute;top:50%;margin-top:-6px;right:0;}
.trendtop .trendtop_right .img1.on {animation: run 2s linear 0s infinite;}

/*top end*/

/*时间选择*/
.times{ padding-top: 0rem; text-align: center;}
.times .tim{ width: 3.1rem; padding:0.25rem 0; display: inline-block; border-radius: 0.1rem; background: #fff; margin:0.4rem 0.1rem 0 0.1rem; font-size: 16px;}
.foremail{ width: 6.4rem; margin:0.4rem auto; border-radius: 0.1rem; background: #fff; overflow: hidden;}
.foremail input{ width: 100%; text-indent: 0.1rem; font-size: 16px; color:#333; padding:0.25rem 0; float: left;}
/*时间选择 end*/
.doexcel{ width: 6.4rem; margin: 0 auto; border-radius: 0.1rem; text-align: center; padding: 0.2rem 0; font-size: 16px; background: #2255D2; color: #fff;}

.valist{ width: 6.9rem; margin:0 auto; padding-top: 1.5rem;}
.vatop{ overflow: hidden; }
.va{ overflow: hidden; background: #fff; padding: 0.2rem; border-radius: 0.1rem; box-shadow: 0 0 0.1rem #eee; margin-bottom: 0.2rem;}
.va .valeft{ width: 5rem; float: left;}
.va .valeft .va_title{ color: #333;}
.va .valeft .va_title .txt2{ color: #999; padding-left: 0.3rem;}
.va .valeft .va_time{ color:#999; padding-top: 0.15rem;}
.va .valeft .va_time .img1{ width: 0.3rem; vertical-align: middle; margin: -0.05rem 0.08rem 0 0;}
.va .varight{ float: right; padding-top: 0.2rem;}
.vatask{ overflow: hidden; border-top: 1px dashed #ddd; margin-top: 0.2rem; padding-top: 0.15rem;}
.vatask .vatask_left{ float: left; line-height: 0.45rem;}
.vatask .vatask_right{ float: right;}
.vatask .vatask_right a{ display: block; height: 0.45rem; line-height: 0.45rem; text-align: center; padding: 0 0.15rem; color: #fff; background: rgba(24,76,204,1); border-radius: 0.1rem;}
</style>
